import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, ClockIcon, CalendarIcon, TagIcon, LinkIcon, HelpCircleIcon, SettingsIcon, BoxIcon, ChevronDownIcon, ChevronRightIcon, CreditCardIcon, FileTextIcon, ReceiptIcon, SparklesIcon } from 'lucide-react';
const Sidebar = () => {
  const location = useLocation();
  const [isLucaGetOpen, setIsLucaGetOpen] = useState(true);
  // Simulate whether the supplier has connected accounting software
  // In a real app, this would come from an API or context
  const [hasConnectedAccounting, setHasConnectedAccounting] = useState(true);
  // Dashboard remains as a standalone item
  const dashboardItem = {
    name: 'Dashboard',
    path: '/',
    icon: HomeIcon
  };
  // Items to be moved under LucaGet
  const lucaGetItems = [{
    name: 'Upcoming Payments',
    path: '/upcoming-payments',
    icon: CalendarIcon
  }, {
    name: 'Payment History',
    path: '/payment-history',
    icon: ClockIcon
  }, {
    name: 'Promo Codes',
    path: '/promo-codes',
    icon: TagIcon,
    comingSoon: true // Add coming soon flag
  }, {
    name: 'Bank Accounts',
    path: '/bank-accounts',
    icon: BoxIcon
  }, {
    name: 'Integrations',
    path: '/integrations',
    icon: LinkIcon
  }];
  // New accounting-related items (only showing Invoices, hiding Bills)
  const accountingItems = [{
    name: 'Invoices',
    path: '/invoices',
    icon: FileTextIcon
  }
  // Bills item removed
  ];
  const bottomNavItems = [{
    name: 'Help & Support',
    path: '/support',
    icon: HelpCircleIcon
  }, {
    name: 'Settings',
    path: '/settings',
    icon: SettingsIcon
  }];
  // Check if any LucaGet submenu item is active
  const isLucaGetActive = [...lucaGetItems, ...(hasConnectedAccounting ? accountingItems : [])].some(item => location.pathname === item.path);
  return <aside className="hidden lg:flex flex-col w-64 border-r border-gray-200 bg-white" data-id="element-55">
      <div className="p-4 border-b border-gray-200" data-id="element-56">
        <Link to="/" className="flex items-center" data-id="element-57">
          <span className="text-xl font-bold text-blue-600" data-id="element-58">LucaPlus</span>
        </Link>
      </div>
      <div className="flex-1 overflow-y-auto py-4" data-id="element-59">
        <nav className="px-2 space-y-1" data-id="element-60">
          {/* Dashboard as a standalone item */}
          <Link to={dashboardItem.path} className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md ${location.pathname === dashboardItem.path ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-61">
            <dashboardItem.icon className={`mr-3 h-5 w-5 ${location.pathname === dashboardItem.path ? 'text-blue-600' : 'text-gray-500 group-hover:text-gray-600'}`} data-id="element-62" />
            {dashboardItem.name}
          </Link>
          {/* LucaGet section with collapsible submenu */}
          <div data-id="element-63">
            <button onClick={() => setIsLucaGetOpen(!isLucaGetOpen)} className={`w-full flex items-center justify-between px-2 py-2 text-sm font-medium rounded-md ${isLucaGetActive ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-64">
              <div className="flex items-center" data-id="element-65">
                <CreditCardIcon className={`mr-3 h-5 w-5 ${isLucaGetActive ? 'text-blue-600' : 'text-gray-500 group-hover:text-gray-600'}`} data-id="element-66" />
                <span data-id="element-67">LucaGet</span>
              </div>
              {isLucaGetOpen ? <ChevronDownIcon className="h-4 w-4" data-id="element-68" /> : <ChevronRightIcon className="h-4 w-4" data-id="element-69" />}
            </button>
            {/* Submenu items */}
            {isLucaGetOpen && <div className="mt-1 pl-10 space-y-1" data-id="element-70">
                {/* Regular LucaGet items */}
                {lucaGetItems.map(item => {
              const isActive = location.pathname === item.path;
              const Icon = item.icon;
              return <Link key={item.name} to={item.path} className={`group flex items-center justify-between px-2 py-2 text-sm font-medium rounded-md ${isActive ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-71">
                      <div className="flex items-center" data-id="element-72">
                        <Icon className={`mr-3 h-5 w-5 ${isActive ? 'text-blue-600' : 'text-gray-500 group-hover:text-gray-600'}`} data-id="element-73" />
                        {item.name}
                      </div>
                      {item.comingSoon && <div className="flex items-center" data-id="element-74">
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800" data-id="element-75">
                            <SparklesIcon className="h-3 w-3 mr-1" data-id="element-76" />
                            Coming Soon
                          </span>
                        </div>}
                    </Link>;
            })}
                {/* Accounting-related items (only shown if accounting software is connected) */}
                {hasConnectedAccounting && <>
                    {accountingItems.map(item => {
                const isActive = location.pathname === item.path;
                const Icon = item.icon;
                return <Link key={item.name} to={item.path} className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md ${isActive ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-77">
                          <Icon className={`mr-3 h-5 w-5 ${isActive ? 'text-blue-600' : 'text-gray-500 group-hover:text-gray-600'}`} data-id="element-78" />
                          {item.name}
                        </Link>;
              })}
                  </>}
              </div>}
          </div>
        </nav>
      </div>
      <div className="p-4 border-t border-gray-200" data-id="element-79">
        <nav className="space-y-1" data-id="element-80">
          {bottomNavItems.map(item => {
          const Icon = item.icon;
          return <Link key={item.name} to={item.path} className="group flex items-center px-2 py-2 text-sm font-medium rounded-md text-gray-700 hover:bg-gray-100" data-id="element-81">
                <Icon className="mr-3 h-5 w-5 text-gray-500 group-hover:text-gray-600" data-id="element-82" />
                {item.name}
              </Link>;
        })}
        </nav>
      </div>
    </aside>;
};
export default Sidebar;